const Tactic = require('../../entities/Tactic');
const { Age }  = require("../Constants");
const TacticNames = require("../Names/TacticNames");

class Conquistadors extends Tactic {
    constructor() {
        super(
            Age.Age2,
            TacticNames.Conquistadors,
            [1, 2, 0],
            "5(3)",
            {}
        )
    }
}

module.exports = Conquistadors;